import React from 'react'
import moment from 'moment';
import { getExtension, getFileFromType, formatBytes } from 'Helpers/Documents';
import { DocumentDownload } from 'assets/images'
import { getColorForName } from 'Helpers/colorPalette';
export default ({
  filename,
  fileSize = 0,
  timestamp,
  fileUrl,
  downloadFile,
  message_type,
  mediaFileKey,
  publisherId,
  mediaFileToken,
  fileKey,
  ...props
}) => {
  const { feedbackDetails: { reporterMobile ,type },name } = props
  const fileExtension = getExtension(filename);
  const placeholder = getFileFromType(null, fileExtension, message_type);
  const formatFileSize = formatBytes(fileSize);
  const nameColor = getColorForName(name);
  const mediaIv = process.env.REACT_APP_MEDIA_ENCRYPT_IV;
  const downloadAttachment =(event) =>{
    event.preventDefault()
    downloadFile({ filename:filename, mediaFileToken:mediaFileToken, encryptKey:fileKey , ivString:mediaIv });

   }
  const isReporter = publisherId.includes(reporterMobile);

  return (
    <div className={ `${ isReporter ? 'repoter' : 'repoted' }` }>
      <div className={ `attachment-block` }>
         {type === 'groupchat' && (
            <div
              className='report-user-name'
              style={ { color: nameColor } }
            >
              { name }
            </div>
          )}
        <div className='attachment'>
          <img alt="file" src={ placeholder } className='attachment-img' />
          <span className='attachment-name'>{ filename }</span>
          <i className="attachment-download" onClick={ downloadAttachment }>
              <DocumentDownload />
            </i>
        </div>
        <div className='attachment-info'>
          <small className='attachment-size'>{ `${ formatFileSize }` }</small>
          <span className='attachment-time'>{ moment(parseInt(timestamp)).format('h:mm A') } </span>
        </div>
      </div>
    </div>
  )
}